import { useCallback, useMemo } from "react";
import { Box, Grid, IconButton } from "@material-ui/core";
import RotateLeftIcon from "@material-ui/icons/RotateLeft";
import { useDispatch } from "react-redux";

import { useAppSelector } from "../../app/hooks";
import { CxQuestion, CX_SCORE_VAL } from "../../entity/entities";
import { QUESTION_TYPE_ATTR_SELECT_SCORE } from "../../constant/Enum";

import { resetScore, selectScore } from "./PreviewReducer";
import { QuestionText } from "../question/QuestionText";
import { RatingScore } from "./RatingScore";

const MAX_SCORE = 5; // cxQuestion.maxScore
const { HEART, CIRCLE, STAR } = QUESTION_TYPE_ATTR_SELECT_SCORE;

export const SelectScore = (props: {
  pageIndex: number;
  questionIndex: number;
  cxQuestion: CxQuestion;
}) => {
  const dispatch = useDispatch();
  const { pageIndex, questionIndex, cxQuestion } = props;
  const questionTypeAttr = cxQuestion.questionTypeAttr ?? HEART;

  const score = useAppSelector((state) => {
    const cxQuestionPage = state.preview.answer[pageIndex];
    const cxAnswer = cxQuestionPage.cxAnswers[questionIndex];

    return cxAnswer.answerScore;
  });

  const scoreWidth = 100.0 / MAX_SCORE;
  let mx = Math.floor(0 + (6 * (10 - MAX_SCORE)) / 5);
  if (mx < 0) {
    mx = 0;
  }
  if (mx > 6) {
    mx = 6;
  }

  let displayResetButton = "none";

  if (!cxQuestion.required && score !== null) displayResetButton = "";

  const handleResetClick = () =>
    dispatch(
      resetScore({
        pageIndex,
        questionIndex,
      })
    );

  const handleIconClick = useCallback(
    (score: CX_SCORE_VAL) =>
      dispatch(
        selectScore({
          pageIndex,
          questionIndex,
          score,
        })
      ),
    [pageIndex, questionIndex, dispatch]
  );

  const widthAndHeightIcon: {
    iconWidth: number | string;
    iconHeight: number | string;
  } = useMemo(() => {
    switch (questionTypeAttr) {
      case HEART:
        return {
          iconWidth: 41,
          iconHeight: 36.3,
        };
      case STAR:
      case CIRCLE:
        return {
          iconWidth: 41,
          iconHeight: 41,
        };

      default:
        return {
          iconWidth: 39,
          iconHeight: 38,
        };
    }
  }, [questionTypeAttr]);

  return (
    <>
      <QuestionText cxQuestion={cxQuestion} />
      <Box position="relative">
        <Box position="absolute" display={displayResetButton}>
          <Grid container>
            <Box>
              <IconButton onClick={handleResetClick}>
                <RotateLeftIcon />
              </IconButton>
            </Box>
          </Grid>
        </Box>
        <Box mx={mx}>
          <RatingScore
            score={score}
            questionTypeAttr={questionTypeAttr}
            scoreWidth={scoreWidth}
            {...widthAndHeightIcon}
            handleIconClick={handleIconClick}
          />
        </Box>
      </Box>
    </>
  );
};
